export enum FinHubTab {
  ORDERS = 'orders',
  QUOTES = 'quotes'
}
